import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { Opportunity } from '../types/Opportunity';
import { DxDataGridComponent } from 'devextreme-angular';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver';
@Component({
  selector: 'opportunities',
  templateUrl: './opportunities.component.html'
})
export class OpportunitiesComponent implements OnInit {
  @ViewChild('opportunitiesGrid', { static: true }) opportunitiesGrid: DxDataGridComponent;
  @ViewChild("header1", { read: ElementRef }) header1: ElementRef;
  _opportunities: Opportunity[];
  _miles: number;
  @Input()
  set opportunities(value: Opportunity[]) {
    this._opportunities = value;
  }

  get opportunities(): Opportunity[] {
    return this._opportunities;
  }

  @Input()
  set miles(value: number) {
    this._miles = value;
    this.header = `Known Gas Users for Opportunities within ${this._miles} miles`
  }

  get miles(): number {
    return this._miles;
  }
  chooserMode: string = 'select';
  header: string;
  constructor() {

  }

  exportExcel(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Opportunities');
    exportDataGrid({
      component: this.opportunitiesGrid.instance,
      worksheet: worksheet,
      customizeCell: ({ gridCell, excelCell }) => {
        if ((gridCell.column.dataField === 'createdDate' || gridCell.column.dataField === 'closingDate' ||
          gridCell.column.dataField === 'onstreamDate') && excelCell._row.number > 1) {
          excelCell.numFmt = 'mm/dd/yyyy';
          excelCell.value = this.dateStringToDate(excelCell.value);
        }
      },
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Opportunities.xlsx');
        });
    });
    e.cancel = true;
  }

  ngOnInit(): void {

  }

  dateStringToDate(dateString) {
    try {
      var year = dateString.substring(0, 4);
      var month = dateString.substring(4, 6);
      var day = dateString.substring(6, 8);
      var date = new Date(year, month - 1, day, 0, 0, 0, 0);
      const offset = date.getTimezoneOffset()
      date = new Date(date.getTime() - (offset * 60 * 1000));
      return date;
    } catch (error) {
      return null;
    }
  }
}